import { CURRENT_TAB } from "../store/types";

const INITIAL_STATE = "Card";

export const tabsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CURRENT_TAB:
      return action.payload
    default:
      return state;
  }
};
